import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { HeroHome as Original } from 'components/organisms'
import { HeroHomeSettings } from './HeroHomeSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { heroHomeSlideItemParams } from '../HeroHomeSlide'
import { useSelector } from 'react-redux'

export const defaultProps = {
  type: 'default',
  theme: 'neutral10',
  viewBreadcrumbs: false
}

export const dynamicProps = []

export const HeroHome: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode((state) => ({
      selected: state.events.selected,
      dragged: state.events.dragged,
      hovered: state.events.hovered,
      customs: state.data.custom,
    }), props)
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }), props)

    const {pagina} = useSelector((state:any) => state.pagina)

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-hero-home ${props.className}`}
      >
        <Original
          item={{
            pk: id,
            children: getItemChildren(enabled, children?.[0], heroHomeSlideItemParams),
          }}
          theme={blockProps.theme}
          type={blockProps.type}
          viewBreadcrumbs={blockProps.viewBreadcrumbs}
          editMode={enabled}
          breadcrumbs={pagina?.pagina?.breadcrumbs}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

HeroHome.craft = withCraft({
  name: 'HeroHome',
  defaultProps: defaultProps,
  settings: HeroHomeSettings,
})
